// 로그인 성공 후 redirect 처리 (Phase 7a — OV03 등 외부 origin 지원).
//
// `redirect` 파라미터가:
// - same-origin path (예: `/dashboard`) → react-router navigate
// - 외부 URL (예: `http://edge:5678/auth/callback`) → whitelist 검증 후
//   `window.location.assign` 으로 fragment 토큰 부착 후 redirect.
//   whitelist 미일치 시 → 토큰 외부 유출 방지 위해 `/` 로 fallback.
//
// 외부 origin whitelist 는 `VITE_ALLOWED_REDIRECT_ORIGINS` 환경변수 (콤마 구분).

import type { NavigateFunction } from 'react-router-dom';

import { getAuthClient } from '@/api/client';

function allowedOrigins(): string[] {
  const raw = (import.meta.env.VITE_ALLOWED_REDIRECT_ORIGINS as string | undefined) ?? '';
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function applyLoginRedirect(
  redirect: string | null | undefined,
  navigate: NavigateFunction,
): void {
  const target = redirect && redirect.length > 0 ? redirect : '/';

  if (/^https?:\/\//.test(target)) {
    let url: URL;
    try {
      url = new URL(target);
    } catch {
      navigate('/', { replace: true });
      return;
    }
    const whitelist = allowedOrigins();
    if (whitelist.includes(url.origin)) {
      const token = getAuthClient().getAccessToken();
      if (token) {
        url.hash = `token=${encodeURIComponent(token)}`;
      }
      window.location.assign(url.toString());
      return;
    }
    // 외부 URL 인데 whitelist 미일치 → 토큰 노출 방지 위해 메인으로
    console.warn('[redirect] origin not in whitelist:', url.origin);
    navigate('/', { replace: true });
    return;
  }

  navigate(target, { replace: true });
}
